export enum PermissionType {
    Private = 0,
    Public = 1,
    InCompany = 2,
    SharedCompanies = 3,
    SharedUsers = 4,
    SharedUserGroups = 5
}